import {atom, useSetAtom} from 'jotai';
import {useCallback} from 'react';

type ExternalUrlModalState = {
  open: boolean;
  url: string;
  text: string;
};

export const externalUrlModalStateAtom = atom<ExternalUrlModalState>({
  open: false,
  text: '',
  url: '',
});

const preprocessUrl = (path: string) => {
  return path.replace(/^\/+/, '');
};

export const useOpenExternalUrlModal = () => {
  const set = useSetAtom(externalUrlModalStateAtom);
  return useCallback(
    ({text, url}: Omit<ExternalUrlModalState, 'open'>) =>
      set({open: true, url: preprocessUrl(url), text: preprocessUrl(text)}),
    [set],
  );
};
